import AddonVariant from "src/api/graphql/__generated__/enums/AddonVariant";

// Keeping this lookup generic for backwards compatibility with new variants

export const ADDON_COPY_MODAL_LABELS: Record<string, string> = {
	[AddonVariant.Link]: "LINK",
	[AddonVariant.Spotify]: "SPOTIFY",
	[AddonVariant.Venmo]: "VENMO",
	[AddonVariant.Location]: "LOCATION",
};
